import { useTranslation } from 'react-i18next';
import { useState, useEffect } from "react";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { ddStyles } from "../../utils/CommonStyles.js";
import FetchUtil from "../../utils/FetchUtil";

let filterList = [];
function setFilterList(data) {
	filterList = data;
}

let chartTypeSet = "";
let locationOptions = [];
let companyOptions = [];
let locationNames = [];
let productOptions = [];
let chartTypeOptions = [];
let commodityOptions = [];
let lotCodeOptions = [];
let bolOptions = [];
let finishedProdLotOptions = [];
let riskOptions = [];
let selectedGroupName = "";
let filterValues = {
	"groupName": "", "chartType": "", "locationList": [],
	"productName": "", "productSku": "", "commodityName": "",
	"companyId": 0, "lotCode": "", "finishedLotCode": "", "bol": "","scoreResult": ""
};
const AnalyticsDateFilter = ({ key, onClickFilterCallback, searchVal, onSearchValChange, selectedChartGroup, userAnalyticsList }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const today = new Date().toISOString().split("T")[0];
	const lastWeekDate = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
	const [search, setSearch] = useState({ startDate: (searchVal.startDate || lastWeekDate), endDate: (searchVal.endDate || today) });
	const [chartTypeSelected, setChartTypeSelected] = useState({ name: "chartType", label: "", value: "" });
	const [locationSelected, setLocationSelected] = useState([]);
	const [productSelected, setProductSelected] = useState({ name: "product", label: "", value: "" });
	const [companySelected, setCompanySelected] = useState({ name: "company", label: "", value: 0 });
	const [commoditySelected, setCommoditySelected] = useState({ name: "commodity", label: "", value: "" });
	const [lotCodeSelected, setLotCodeSelected] = useState({ name: "lotCode", label: "", value: "" });
	const [finishedLotCodeSelected, setFinishedLotCodeSelected] = useState({ name: "finishedLotCode", label: "", value: "" });
	const [bolSelected, setBolSelected] = useState({ name: "bol", label: "", value: "" });
	const [riskSelected, setRiskSelected] = useState({ name: "risk", label: "", value: "" });
	const [filterChanged, setFilterChanged] = useState(false);
	const [dataFound, setDataFound] = useState(false);
	
	useEffect(() => {
		locationNames = [];
		chartTypeSet = "";
		setChartTypeValues();
	}, [selectedChartGroup, userAnalyticsList]);

	useEffect(() => {
		locationNames = [];
		setDataFound(false);
		filterValues = {
			...filterValues, "locationList": [],
			"productName": "", "productSku": "", "commodityName": "",
			"companyId": 0, "lotCode": "", "finishedLotCode": "", "bol": "", "scoreResult": ""
		};
		resetAllFields();
		chartTypeSet = chartTypeSelected.value;
		selectedGroupName = getGroupName(chartTypeSet);
		if (selectedGroupName) {
			retrieveFilters(search.startDate, search.endDate, selectedGroupName);
		}

	}, [search, chartTypeSelected]);

	function getGroupName(chartType) {
		let groupName = "";
		if (userAnalyticsList && userAnalyticsList.length > 0) {
			userAnalyticsList.map((eachAnalyticsAccess) => {
				if ((selectedChartGroup === eachAnalyticsAccess.analyticsName) && chartType === eachAnalyticsAccess.analyticsSubName) {
					groupName = eachAnalyticsAccess.surveyName;
				}
			});
		}
		return groupName;
	}
	
	function resetAllFields() {
		locationOptions = [];
		locationNames = [];
		companyOptions = [];
		productOptions = [];
		commodityOptions = [];
		lotCodeOptions = [];
		finishedProdLotOptions = [];
		bolOptions = [];
		setCompanySelected({ name: "company", label: "", value: 0 });
		setLocationSelected([]);
		setProductSelected({ name: "product", label: "", value: "" });
		setCommoditySelected({ name: "commodity", label: "", value: "" });
		setLotCodeSelected({ name: "lotCode", label: "", value: "" });
		setFinishedLotCodeSelected({ name: "finishedLotCode", label: "", value: "" });
		setBolSelected({ name: "bol", label: "", value: "" });
		setFilterChanged(true);
	}


	const valueHandler = (e) => {
		const { name, value } = e.target;
		setSearch({ ...search, [name]: value });

		if (onSearchValChange) {
			let startDate = search.startDate;
			let endDate = search.endDate;
			if (name === "startDate") {
				startDate = value;
			} else if (name === "endDate") {
				endDate = value;
			}
			onSearchValChange(startDate, endDate);
		}
	}
	const onClickSearch = (event) => {
		//console.log("onClickSearch for:" + search.startDate + " end:" + search.endDate + " chart:" + filterValues.chartType);
		onClickFilterCallback(search.startDate, search.endDate, filterValues);
	}


	function retrieveFilters(startDate, endDate, groupName) {
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", forSupplier: false,
				startDate: startDate, endDate: endDate,
				groupList: [groupName],
				forAllCompany: true,
			}),
		};
		try {
			FetchUtil.fetchAPI("GetSearchFilter", "/Service/QuestionService/GetSearchFilter", requestOptions, retrieveFiltersSuccess, retrieveFiltersFail);
		} catch (error) {
			console.log([error.message]);
		}
	}

	function retrieveFiltersFail(redirect) {
		if (redirect) {
			navigate("/");
		}
	}

	function retrieveFiltersSuccess(responseData) {

		let searchFilterResponse;
		if (responseData) {
			searchFilterResponse = responseData.searchFilterResponse;
			if (searchFilterResponse && searchFilterResponse.errorCode === "0") {
				setFilterList(searchFilterResponse.filterList);
				setCompanyValues(searchFilterResponse.filterList);
				setDataFound( (searchFilterResponse.filterList.length > 0) );
			} else if (searchFilterResponse && searchFilterResponse.errorCode === "114") {
				console.log([t("error.sessionTimeout")]);
				navigate("/");
			} else if (searchFilterResponse) {
				console.log([searchFilterResponse.errorMessage]);
			}
		}
	}


	const chartTypeHandler = (selectedOption, action) => {
		let selectedChartName = selectedOption ? selectedOption.value : "";
		let selectedChartDescription = selectedOption ? selectedOption.label : "";
		setChartTypeSelected({ ...chartTypeSelected, label: selectedChartDescription, value: selectedChartName });
		filterValues["groupName"] = getGroupName(selectedChartName);
		filterValues["chartType"] = selectedChartName;
	}

	const companyHandler = (selectedOption, action) => {
		let companyId = selectedOption ? selectedOption.value : 0;
		let selectedCompanyName = selectedOption ? selectedOption.label : "";
		setCompanySelected({ ...companySelected, label: selectedCompanyName, value: companyId });
		filterValues["companyId"] = companyId;
		filterValues = {
			...filterValues, "locationList": [],
			"productName": "", "productSku": "", "commodityName": "",
			"lotCode": "", "finishedLotCode": "", "bol": "","scoreResult": ""
		};
		setLocationValues(filterList, companyId);
	}

	const locationHandler = (selectedOptions, action) => {
		let locationValue = {};
		let locationList = [];
		locationNames = [];
		if (selectedOptions && selectedOptions.length > 0) {
			selectedOptions.map((aOption) => {
				//console.log("location selected :" + aOption.label);
				locationValue.label = aOption ? aOption.label : "";
				locationValue.value = aOption ? aOption.value : "";
				if (locationValue.value) {
					locationList.push(locationValue);
					locationNames.push(locationValue.value);
				}
				locationValue = {};
			});
		}
		setLocationSelected(locationList);
		filterValues = {
			...filterValues, "productName": "", "productSku": "", "commodityName": "",
			"lotCode": "", "finishedLotCode": "", "bol": "","scoreResult": ""
		};
		filterValues["locationList"] = locationNames;
		if (selectedGroupName === "Farm" || selectedGroupName === "Harvest") {
			setCommodityValues(filterList, locationNames);
		} else {
			setProductValues(filterList, locationNames);
		}
	}

	const productHandler = (selectedOption, action) => {
		let selectedProduct = selectedOption ? selectedOption.value : "";
		let selectedProductName = selectedOption ? selectedOption.label : "";
		setProductSelected({ ...productSelected, label: selectedProductName, value: selectedProduct });

		if (filterList && filterList.length > 0) {
			for (let i = 0; i < filterList.length; i++) {
				if (filterList[i].productDisplayName === selectedProductName) {
					filterValues["productName"] = filterList[i].productName;
					filterValues["productSku"] = filterList[i].productSku;
					filterValues["commodityName"] = filterList[i].commodityName;
					break;
				}
			}
		}
		filterValues = { ...filterValues, "lotCode": "", "finishedLotCode": "", "bol": "","scoreResult": "" };
		setFinishedProductLotValues(filterList, filterValues["commodityName"], filterValues["productName"], filterValues["productSku"]);
	}

	const commodityHandler = (selectedOption, action) => {
		let commodityName = selectedOption ? selectedOption.value : "";
		setCommoditySelected({ ...commoditySelected, label: commodityName, value: commodityName });
		filterValues["commodityName"] = commodityName;
		filterValues = { ...filterValues, "productName": "", "productSku": "", "lotCode": "", "finishedLotCode": "", "bol": "","scoreResult": "" };
		//setLotCodeValues(filterList, commodityName);
		setBolValues(filterList, commodityName);
	}

	const lotCodeHandler = (selectedOption, action) => {
		let lotCode = selectedOption ? selectedOption.value : "";
		setLotCodeSelected({ ...lotCodeSelected, label: lotCode, value: lotCode });
		filterValues = { ...filterValues, "finishedLotCode": "", "scoreResult": "" };
		filterValues["lotCode"] = lotCode;
		setRiskValues(filterList, lotCode, "");
	}

	const finishedLotCodeHandler = (selectedOption, action) => {
		let finishedLotCode = selectedOption ? selectedOption.value : "";
		setFinishedLotCodeSelected({ ...finishedLotCodeSelected, label: finishedLotCode, value: finishedLotCode });
		filterValues = { ...filterValues, "lotCode": "", "scoreResult": "" };
		filterValues["finishedLotCode"] = finishedLotCode;
		setRiskValues(filterList, "", finishedLotCode);
	}
	
	const bolHandler = (selectedOption, action) => {
			let bol = selectedOption ? selectedOption.value : "";
			setBolSelected({ ...bolSelected, label: bol, value: bol });
			filterValues = { ...filterValues, "finishedLotCode": "", "scoreResult": "" };
			filterValues["bol"] = bol;
			setRiskValues(filterList, bol, "");
		}
		
	const riskHandler = (selectedOption, action) => {
		let selectedRisk = selectedOption ? selectedOption.value : "";
		let selectedRiskName = selectedOption ? selectedOption.label : "";
		setRiskSelected({ ...riskSelected, label: selectedRiskName, value: selectedRisk });
		filterValues["scoreResult"] = selectedRisk;
		setFilterChanged(true);
	}


	function setChartTypeValues() {
		//console.log("setChartTypeValues for:"+selectedChartGroup+ " len:"+userAnalyticsList.length);
		let chartTypeValue = {};
		let dupChartType = {};
		filterValues["chartType"] = "";
		chartTypeOptions = [];
		chartTypeOptions.push({ label: "", value: "" });
		if (userAnalyticsList && userAnalyticsList.length > 0) {
			userAnalyticsList.map((eachAnalyticsAccess) => {
				if ((selectedChartGroup === eachAnalyticsAccess.analyticsName) && !dupChartType[eachAnalyticsAccess.analyticsSubName]) {
					chartTypeValue.label = eachAnalyticsAccess.analyticsDescription;
					chartTypeValue.value = eachAnalyticsAccess.analyticsSubName;
					chartTypeOptions.push(chartTypeValue);
					chartTypeValue = {};
					dupChartType[eachAnalyticsAccess.analyticsSubName] = 1;
				}
			});
		}
		if (chartTypeOptions && chartTypeOptions.length > 2) {
			chartTypeOptions.sort((a, b) => a.label.localeCompare(b.label));
		}
		setChartTypeSelected({ ...chartTypeSelected, label: "", value: "" });
		setFilterChanged(true);
	}

	function setCompanyValues(filterObj) {
		let companyValue = {};
		let dupCompany = {};
		companyOptions = [];
		companyOptions.push({ label: "", value: 0 });
		if (filterObj && filterObj.length > 0) {
			filterObj.map((filter) => {
				if (!dupCompany[filter.companyId] && (filter.groupName === selectedGroupName)) {
					companyValue.label = filter.companyName;
					companyValue.value = filter.companyId;
					companyOptions.push(companyValue);
					companyValue = {};
					dupCompany[filter.companyId] = 1;
				}

			});
		}
		if (companyOptions && companyOptions.length > 2) {
			companyOptions.sort((a, b) => a.label.localeCompare(b.label));
		}
		setCompanySelected({ ...companySelected, label: "", value: 0 });
		setLocationValues(filterList, 0);
		setFilterChanged(true);
	}

	function setLocationValues(filterObj, selectedCompanyId) {
		let locationValue = {};
		let dupLoc = {};
		setLocationSelected([]);
		locationOptions = [];
		locationOptions.push({ label: "", value: "" });
		if (filterObj && filterObj.length > 0) {
			filterObj.map((filter) => {
				if (!dupLoc[filter.locationName] && (filter.groupName === selectedGroupName)
					&& (selectedCompanyId === 0 || selectedCompanyId === filter.companyId)) {
					locationValue.label = filter.locationName;
					locationValue.value = filter.locationName;
					locationOptions.push(locationValue);
					locationValue = {};
					dupLoc[filter.locationName] = 1;
				}

			});
		}
		if (locationOptions && locationOptions.length > 2) {
			locationOptions.sort((a, b) => a.label.localeCompare(b.label));
		}
		if (selectedGroupName === "Farm" || selectedGroupName === "Harvest") {
			setCommodityValues(filterList, []);
		} else {
			setProductValues(filterList, []);
		}
		setFilterChanged(true);
	}

	function setCommodityValues(filterObj, locationList) {
		let commodityValue = {};
		let dupCommodity = {};
		let selectedCompanyId = filterValues["companyId"];
		commodityOptions = [];
		commodityOptions.push({ label: "", value: "" });
		if (filterObj && filterObj.length > 0) {
			filterObj.map((filter) => {
				if (!dupCommodity[filter.commodityName] && (filter.groupName === selectedGroupName)
					&& (selectedCompanyId === 0 || selectedCompanyId === filter.companyId)
					&& (!locationList || locationList.length === 0 || locationList.includes(filter.locationName))) {
					commodityValue.label = filter.commodityName;
					commodityValue.value = filter.commodityName;
					commodityOptions.push(commodityValue);
					dupCommodity[filter.commodityName] = 1;
					commodityValue = {};
				}

			});
		}
		if (commodityOptions && commodityOptions.length > 2) {
			commodityOptions.sort((a, b) => a.label.localeCompare(b.label));
		}
		setCommoditySelected({ ...commoditySelected, label: "", value: "" });
		//setLotCodeValues(filterList, "");
		setBolValues(filterList, "");
		setFilterChanged(true);
	}


	function setProductValues(filterObj, locationList) {
		let productValue = {};
		let dupProduct = {};
		let selectedCompanyId = filterValues["companyId"];
		productOptions = [];
		productOptions.push({ label: "", value: "" });
		if (filterObj && filterObj.length > 0) {
			filterObj.map((filter) => {
				if (filter.productDisplayName && !dupProduct[filter.productDisplayName] && (filter.groupName === selectedGroupName)
					&& (selectedCompanyId === 0 || selectedCompanyId === filter.companyId)
					&& (!locationList || locationList.length === 0 || locationList.includes(filter.locationName))) {
					productValue.label = filter.productDisplayName;
					productValue.value = filter.productDisplayName;
					productOptions.push(productValue);
					productValue = {};
					dupProduct[filter.productDisplayName] = 1;
				}
			});
		}
		if (productOptions && productOptions.length > 2) {
			productOptions.sort((a, b) => a.label.localeCompare(b.label));
		}
		setProductSelected({ ...productSelected, label: "", value: "" });
		setFinishedProductLotValues(filterList, "", "", "");
		setFilterChanged(true);
	}

	function setLotCodeValues(filterObj, commodityName) {
		let lotCodeValue = {};
		let duplotCode = {};
		let selectedCompanyId = filterValues["companyId"];
		let locationList = filterValues["locationList"];
		lotCodeOptions = [];
		lotCodeOptions.push({ label: "", value: "" });
		if (filterObj && filterObj.length > 0) {
			filterObj.map((filter) => {
				if (filter.lotCode && !duplotCode[filter.lotCode] && (filter.groupName === selectedGroupName)
					&& (selectedCompanyId === 0 || selectedCompanyId === filter.companyId)
					&& (!locationList || locationList.length === 0 || locationList.includes(filter.locationName))
					&& (!commodityName || commodityName === filter.commodityName)
				) {
					lotCodeValue.label = filter.lotCode;
					lotCodeValue.value = filter.lotCode;
					lotCodeOptions.push(lotCodeValue);
					lotCodeValue = {};
					duplotCode[filter.lotCode] = 1;
				}
			});
		}
		if (lotCodeOptions && lotCodeOptions.length > 2) {
			lotCodeOptions.sort((a, b) => a.label.localeCompare(b.label));
		}
		setLotCodeSelected({ ...lotCodeSelected, label: "", value: "" });
		setRiskValues(filterList, "", "") ;
		setFilterChanged(true);
	}
	
	function setBolValues(filterObj, commodityName) {
			let bolValue = {};
			let dupbol = {};
			let selectedCompanyId = filterValues["companyId"];
			let locationList = filterValues["locationList"];
			bolOptions = [];
			bolOptions.push({ label: "", value: "" });
			if (filterObj && filterObj.length > 0) {
				filterObj.map((filter) => {
					if (filter.bol && !dupbol[filter.bol] && (filter.groupName === selectedGroupName)
						&& (selectedCompanyId === 0 || selectedCompanyId === filter.companyId)
						&& (!locationList || locationList.length === 0 || locationList.includes(filter.locationName))
						&& (!commodityName || commodityName === filter.commodityName)
					) {
						bolValue.label = filter.bol;
						bolValue.value = filter.bol;
						bolOptions.push(bolValue);
						bolValue = {};
						dupbol[filter.bol] = 1;
					}
				});
			}
			if (bolOptions && bolOptions.length > 2) {
				bolOptions.sort((a, b) => a.label.localeCompare(b.label));
			}
			setBolSelected({ ...bolSelected, label: "", value: "" });
			setRiskValues(filterList, "", "") ;
			setFilterChanged(true);
		}
		
	function setFinishedProductLotValues(filterObj, commodityName, productName, productSku) {
		let finishedLotValue = {};
		let dupfinishedLot = {};
		let selectedCompanyId = filterValues["companyId"];
		let locationList = filterValues["locationList"];
		finishedProdLotOptions = [];
		finishedProdLotOptions.push({ label: "", value: "" });
		if (filterObj && filterObj.length > 0) {
			filterObj.map((filter) => {
				if (filter.finishedLotCode && !dupfinishedLot[filter.finishedLotCode] && (filter.groupName === selectedGroupName)
					&& (selectedCompanyId === 0 || selectedCompanyId === filter.companyId)
					&& (!locationList || locationList.length === 0 || locationList.includes(filter.locationName))
					&& (!commodityName || filter.commodityName === commodityName)
					&& (!productName || filter.productName === productName)
					&& (!productSku || filter.productSku === productSku)
				) {
					finishedLotValue.label = filter.finishedLotCode;
					finishedLotValue.value = filter.finishedLotCode;
					finishedProdLotOptions.push(finishedLotValue);
					finishedLotValue = {};
					dupfinishedLot[filter.finishedLotCode] = 1;
				}
			});
		}
		if (finishedProdLotOptions && finishedProdLotOptions.length > 2) {
			finishedProdLotOptions.sort((a, b) => a.label.localeCompare(b.label));
		}
		setFinishedLotCodeSelected({ ...finishedLotCodeSelected, label: "", value: "" });
		setRiskValues(filterList, "", "") ;
		setFilterChanged(true);
	}
	
	function getRiskLabel(risk) {
		let riskLabel = "";
		switch (risk) {
			case 'L':
				riskLabel = t("page.ready");
				break;
			case 'M':
				riskLabel = t("page.inspect");
				break;
			case 'H':
				riskLabel = t("page.pause");
				break;
			default:
				riskLabel = "";
		}
		return riskLabel;
	}

	function setRiskValues(filterObj, bolVal, finishedLotCode) {
		let riskValue = {};
		let dupRisk = {};
		let selectedCompanyId = filterValues["companyId"];
		let locationList = filterValues["locationList"];
		let productName = filterValues["productName"];
		let productSku = filterValues["productSku"];
		let commodityName =	filterValues["commodityName"];
		riskOptions = [];
		riskOptions.push({ label: "", value: "" });
		if (filterObj && filterObj.length > 0) {
			filterObj.map((filter) => {
				if (!dupRisk[filter.scoreResult] && (filter.groupName === selectedGroupName)
				 && (selectedCompanyId === 0 || selectedCompanyId === filter.companyId)
				&& (!locationList || locationList.length === 0 || locationList.includes(filter.locationName))
					&& (!commodityName || filter.commodityName === commodityName)
					&& (!productName || filter.productName === productName)
					&& (!productSku || filter.productSku === productSku)
					&& (( !bolVal && !finishedLotCode ) || (filter.bol === bolVal  && filter.finishedLotCode === finishedLotCode)) ) {
					riskValue.label = getRiskLabel(filter.scoreResult);
					if (riskValue.label) {
						riskValue.value = filter.scoreResult;
						riskOptions.push(riskValue);
						dupRisk[filter.scoreResult] = 1;
					}

					riskValue = {};
				}
			});
		}
		if (riskOptions && riskOptions.length > 2) {
			riskOptions.sort((a, b) => a.label.localeCompare(b.label));
		}
		setRiskSelected({ ...riskSelected, label: "", value: "" });
		setFilterChanged(true);
	}


	return (

		<div key={key}>
			<div class="row form-group search-box-sm">
				<div class="col">
					<div className="form-group search-dd-sm">
						<label htmlFor="chartType" className="form-label">
							{t("page.analytics")}
							<span style={{ "color": "red", fontWeight: "bold" }}>*</span>
						</label>
						<Select
							name="chartType"
							id="chartType"
							options={chartTypeOptions}
							onChange={chartTypeHandler}
							placeholder={""}
							value={chartTypeSelected}
							isSearchable={filterChanged}
							isClearable={true}
							className="myselect"
							inputId="chartType-input"
							styles={ddStyles}
						/>
					</div>
				</div>
			</div>
			<div class="row form-group search-box-sm">
				<div class="col" style={{ "maxWidth": "fit-content", "minWidth": "fit-content" }}>
					<div style={{ "display": "inline-block", "marginRight": "5px" }}>
						<label htmlFor="startDate" className="form-label">
							{t("page.startDate")}
							<span style={{ "color": "red", fontWeight: "bold" }}>*</span>
						</label>
						<input
							type="date"
							name="startDate"
							id="startDate"
							value={search.startDate || lastWeekDate}
							onChange={valueHandler}
							max={today}
							className="form-control rounded-pill shadow-sm px-4 "
						/>
					</div>
				</div>
			</div>
			<div class="row form-group search-box-sm">
				<div class="col" style={{ "maxWidth": "fit-content", "minWidth": "fit-content" }}>
					<div style={{ "display": "inline-block", "marginRight": "5px" }}>
						<label htmlFor="endDate" className="form-label">
							{t("page.endDate")}
							<span style={{ "color": "red", fontWeight: "bold" }}>*</span>
						</label>
						<input
							type="date"
							name="endDate"
							id="endDate"
							value={search.endDate || today}
							onChange={valueHandler}
							max={today}
							className="form-control rounded-pill shadow-sm px-4 "
						/>
					</div>
				</div>
			</div>
			<div class="row form-group search-box-sm">
				<div class="col">
					<div className="form-group search-dd-sm">
						<label htmlFor="company" className="form-label">
							{t("page.company")}
						</label>
						<Select
							noOptionsMessage={() => null}
							name="company"
							id="company"
							options={companyOptions}
							onChange={companyHandler}
							placeholder={""}
							value={companySelected}
							isSearchable={filterChanged}
							isClearable={true}
							className="myselect"
							inputId="company-input"
							styles={ddStyles}
						/>
					</div>
				</div>
			</div>
			<div class="row form-group search-box-sm">
				<div class="col">
					<div className="form-group search-dd-sm">
						<label htmlFor="location" className="form-label">
							{t("page.location")}
						</label>
						<Select
							isMulti
							noOptionsMessage={() => null}
							name="location"
							id="location"
							options={locationOptions}
							onChange={locationHandler}
							placeholder={""}
							value={locationSelected}
							isSearchable={filterChanged}
							isClearable={true}
							className="myselect"
							inputId="location-input"
							styles={ddStyles}
						/>
					</div>
				</div>
			</div>
			<div class="row form-group search-box-sm">
				<div class="col">
					<div className="form-group search-dd-sm">
						{(selectedGroupName === "Farm" || selectedGroupName === "Harvest") ?
							(<>
								<label htmlFor="commodity" className="form-label">
									{t("page.commodity")}
								</label>
								<Select
									name="commodity"
									id="commodity"
									options={commodityOptions}
									onChange={commodityHandler}
									placeholder={""}
									value={commoditySelected}
									isSearchable={filterChanged}
									isClearable={true}
									className="myselect"
									inputId="product-input"
									styles={ddStyles}
								/>
							</>)
							: (<>
								<label htmlFor="product" className="form-label">
									{t("page.product")}
								</label>
								<Select
									name="product"
									id="product"
									options={productOptions}
									onChange={productHandler}
									placeholder={""}
									value={productSelected}
									isSearchable={filterChanged}
									isClearable={true}
									className="myselect"
									inputId="product-input"
									styles={ddStyles}
								/>
							</>)

						}

					</div>
				</div>
			</div>
			<div class="row form-group search-box-sm">
				<div class="col">
					<div className="form-group search-dd-sm">
						{(selectedGroupName === "Farm" || selectedGroupName === "Harvest") ?
							(<>
								<label htmlFor="bol" className="form-label">
									{t("page.harvest.bol.abrv")}
								</label>
								<Select
									name="bol"
									id="bol"
									options={bolOptions}
									onChange={bolHandler}
									placeholder={""}
									value={bolSelected}
									isSearchable={filterChanged}
									isClearable={true}
									className="myselect"
									inputId="bol-input"
									styles={ddStyles}
								/>
							</>) :
							(<>
								<label htmlFor="finishedLotCode" className="form-label">
									{t("page.finishedLotCode")}
								</label>
								<Select
									name="finishedLotCode"
									id="finishedLotCode"
									options={finishedProdLotOptions}
									onChange={finishedLotCodeHandler}
									placeholder={""}
									value={finishedLotCodeSelected}
									isSearchable={filterChanged}
									isClearable={true}
									className="myselect"
									inputId="finlot-input"
									styles={ddStyles}
								/></>)}
					</div>
				</div>
			</div>
			<div class="row form-group search-box-sm">
				<div class="col">
					<div className="form-group search-dd-sm">
						<label htmlFor="risk" className="form-label">
							{t("page.eval")}
						</label>
						<Select
							name="risk"
							id="risk"
							options={riskOptions}
							onChange={riskHandler}
							placeholder={""}
							value={riskSelected}
							isSearchable={filterChanged}
							isClearable={true}
							className="myselect"
							inputId="risk-input"
							styles={ddStyles}
						/>
					</div>
				</div>
			</div>
			<div class="row form-group search-box-sm">
				<div class="col">
					<div style={{ "display": "inline-block", marginRight: "50px" }}>

					</div>
					<div style={{ "display": "inline-block" }}>
						<button
							type="submit"
							className="btn btn-primary btn-block search-button"
							onClick={onClickSearch}
							disabled={!dataFound}
						>
							<span class="fa fa-search fa-2">{' '}</span>{t("page.search")}
						</button>
					</div>
					<div style={{ "display": "inline-block", marginRight: "50px" }}>

					</div>
				</div>
			</div>
		</div>
	)
}

export default AnalyticsDateFilter;